var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurgery = function SvgSurgery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C83133",
    d: "M23.107 1.393a3.5 3.5 0 0 1 0 4.95l-7.425 7.425a1 1 0 0 1-1.327.077l-.087-.077-7.071 7.07q-.082.084-.168.161L20.5 21a.5.5 0 1 1 0 1h-15l-.07-.005a5.2 5.2 0 0 1-4.167-.174l-.182-.094a1 1 0 0 1-.248-1.595l9.9-9.9a1 1 0 0 1 0-1.414l7.424-7.425a3.5 3.5 0 0 1 4.95 0M13.56 13.061l-2.122-2.122-9.9 9.9.183.094c1.59.774 3.507.46 4.768-.801zm3.535-2.122-3.535-3.535-2.122 2.121 3.536 3.536zM22.4 2.101a2.5 2.5 0 0 0-3.535 0l-4.596 4.596 3.535 3.535L22.4 5.636a2.5 2.5 0 0 0 0-3.535"
  })));
};
export default SvgSurgery;